import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography, Grid, Button, CircularProgress,
} from '@material-ui/core';
import { doFetch } from '@trdk/style/Redux/fetch.actions';
import clsx from 'clsx';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import DialogBox from '../components/dialog-box';
import TitleField from '../components/title-field';
import InfoCard from '../components/info-card';
import ListValues from '../components/list-values';
import StyledTable from '../components/table/styled-table';
import CustomTableRow from '../components/table/custom-table-row';
import CustomTableCell from '../components/table/custom-table-cell';
import {
  getElementBySysId, formatDatePeriod, getLocationName, getWorkPlanFromAssignmentList,
  getActiveControl, getAllElementsExceptOne, formatDate, getViolationSeverityStr,
  CONTROL_STATUS_NEEDS_ADDITIONAL_REPORT, getMostRecentCompletedControl,
  sortByNewestStartTime, convertDateStrToUseSlash, formatLicenseDatePeriod, getLicenseTypeLabel,
  dateTimeStrToHourAndMin, sortByNewestFromStr, sortByNumberAlphabetically,
} from '../utils';
import { fetchControls, fetchReactions } from '../services/fetch/load-form-service';
import NotificationBox from '../components/notification-box';

class License extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
    };
  }

  componentDidMount() {
    const {
      match: { params: { id } },
      licenses: { payload: licensesPayload },
    } = this.props;
    const license = getElementBySysId(licensesPayload, id);


    this.fetchControls();

    if (license.licenseType === 'tobakk' || license.licenseType === 'tobakk-midlertidig') {
      this.fetchReactions();
    }
  }

  fetchControls = () => {
    const {
      dispatch,
      match: { params: { id } },
    } = this.props;
    dispatch(doFetch('LICENSE_CONTROLS', fetchControls(id, null)
      .then((res) => {
        if (!res.ok) { throw res; }
        return res.json();
      })));
  }

  fetchReactions = () => {
    const {
      dispatch,
      match: { params: { id } },
    } = this.props;
    dispatch(doFetch('LICENSE_REACTIONS', fetchReactions(id)
      .then((res) => {
        if (!res.ok) { throw res; }
        return res.json();
      })));
  }

  render() {
    const {
      classes, history, match: { params: { id } },
      licenses: { payload: licensesPayload },
      assignments: { payload: assignmentsPayload },
      licenseControls: {
        fetching: fetchingControls,
        fetched: fetchedControls,
        errorFetchingControls,
        payload: controlsPayload,
      },
      licenseReactions: {
        fetching: fetchingReactions,
        fetched: fetchedReactions,
        error: errorFetchingReactions,
        payload: reactionsPayload,
      },
      activeWorkPlan,
    } = this.props;
    const { openDialog } = this.state;

    const workPlanId = activeWorkPlan ? activeWorkPlan.sysId : '';
    const license = getElementBySysId(licensesPayload, id);
    if (license == null) {
      return (
        <div>
          {`Ingen bevilling funnet med sysId: ${id}`}
        </div>
      );
    }

    if ((fetchingControls && !fetchedControls) || (fetchingReactions && !fetchedReactions)) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    if ((fetchedControls && errorFetchingControls)
    || (fetchedReactions && errorFetchingReactions)) {
      return (
        <Typography>
          En feil har oppstått under henting av data tilknyttet denne bevillingen.
        </Typography>
      );
    }

    const isTobaccoLicense = license.licenseType === 'tobakk' || license.licenseType === 'tobakk-midlertidig';

    const activeControl = getActiveControl(controlsPayload);
    const isActiveControlInStateNeedsAdditionalReport = activeControl
    && activeControl.status === CONTROL_STATUS_NEEDS_ADDITIONAL_REPORT;
    const isActiveControlAdditionalReportSubmitted = isActiveControlInStateNeedsAdditionalReport && activeControl.additionalReport && activeControl.additionalReport !== '';

    const mostRecentCompletedControl = getMostRecentCompletedControl(controlsPayload);
    const isControlRecentlyCompleted = mostRecentCompletedControl && (
      Math.abs(new Date() - new Date(
        convertDateStrToUseSlash(mostRecentCompletedControl.stopTime),
      )) < 1000 * 30
    );

    const oldControls = getAllElementsExceptOne(controlsPayload, activeControl);

    const isWorkPlanSelected = workPlanId && workPlanId !== '';
    const workPlan = isWorkPlanSelected
      ? getWorkPlanFromAssignmentList(assignmentsPayload, workPlanId) : null;
    const isLicenseInWorkPlan = (
      workPlan && workPlan.licensesSysId && workPlan.licensesSysId.includes(id)
    );

    return (
      <div>
        <TitleField
          title={getLocationName(license)}
          subtitle={getLicenseTypeLabel(license.licenseType)}
        />

        {isControlRecentlyCompleted && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <NotificationBox
                variant="success"
                header="Rapport innsendt"
                text="En rapport har blitt innsendt for denne bevillinga."
                showIcon
                margin="2rem 0"
              />
            </Grid>
          </Grid>
        )}

        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={9}>
              <Typography variant="h6" color="primary">
                {!activeControl && ('Ny kontroll')}
                {activeControl && ('Aktiv kontroll')}
              </Typography>
              <Typography>
                {!activeControl && ('Registrer en ny kontroll for denne bevillinga')}
                {activeControl && !isActiveControlInStateNeedsAdditionalReport && (
                  'Det er registrert en kontroll på denne bevillinga som ikke er innsendt '
                  + 'til saksbehandler ennå.'
                )}
                {isActiveControlInStateNeedsAdditionalReport
                && !isActiveControlAdditionalReportSubmitted && (
                  <strong>
                    {`Det er registrert en kontroll på denne bevillinga, med ${isTobaccoLicense ? '' : 'grove '}brudd/avvik. En tilleggsrapport må ettersendes.`}
                  </strong>
                )}
                {isActiveControlAdditionalReportSubmitted && (
                  'Det er registrert en kontroll på denne bevillinga, med tilleggsrapport. '
                  + 'Tilleggsrapporten kan redigeres tom. 2 dager etter kontrolldato.'
                )}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3} className={classes.flex}>
              <div />
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  if (activeControl) {
                    history.push(`${license.sysId}/kontroll--${activeControl.sysId}`);
                  } else if (isWorkPlanSelected && isLicenseInWorkPlan) {
                    history.push(`${license.sysId}/ny-kontroll`);
                  } else {
                    this.setState({ openDialog: true });
                  }
                }}
              >
                {!activeControl && ('Registrer ny kontroll')}
                {activeControl && ('Åpne kontrollskjema')}
              </Button>
              <DialogBox
                title={isWorkPlanSelected ? 'Ikke del av arbeidsplan' : 'Ingen arbeidsplan valgt'}
                text={(
                  <>
                    {isWorkPlanSelected ? 'Denne bevillinga er ikke del av valgt arbeidsplan.'
                      : 'Det er ikke valgt noen arbeidsplan.'
                    }
                    <br />
                    En ny kontroll vil ikke bli tilknyttet noe kontrolloppdrag/arbeidsplan.
                    <br />
                    Vil du starte kontroll på denne bevillinga likevel?
                  </>
                )}
                handleClose={() => this.setState({ openDialog: false })}
                handleAccept={() => history.push(`${license.sysId}/ny-kontroll`)}
                open={openDialog}
              />
            </Grid>
          </Grid>
        </InfoCard>
        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">
                Bevillingshaver
              </Typography>
              <ListValues values={{
                ...license.licensee,
                address: license.licensee.address.city ? (
                  `${license.licensee.address.streetAddress}, ${license.licensee.address.postalCode} ${license.licensee.address.city}`)
                  : undefined,
                companyCeo: license.location.ceo && license.location.ceo.firstName
                  && `${license.location.ceo.firstName} ${license.location.ceo.lastName}`,
                companyChairman: license.location.chairman && license.location.chairman.firstName
                  && `${license.location.chairman.firstName} ${license.location.chairman.lastName}`,
              }}
              />
            </Grid>
          </Grid>
        </InfoCard>
        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">
                Informasjon om stedet
              </Typography>
              <ListValues values={{
                address: license.location.address.streetAddress ? (
                  `${license.location.address.streetAddress}, ${license.location.address.postalCode} ${license.location.address.city}`)
                  : 'Lokasjon uten gateadresse',
                tlf: license.location.tlf,
                outdoorServing: license.licenseType === 'skjenk' && (
                  license.location.outdoorServing ? 'Ja' : 'Nei'
                ),
                areaIndoor: license.location.area && license.location.area.indoor,
                areaOutdoor: license.location.area && license.location.area.outdoor,
                group3: license.licenseType === 'skjenk' && (
                  license.location.group3 ? 'Ja' : 'Nei'
                ),
                alcoholImport: license.licenseType === 'skjenk' && (
                  license.location.alcoholImport ? 'Ja' : 'Nei'
                ),
                manufacturing: license.licenseType === 'skjenk' && (
                  license.location.manufacturing ? 'Ja' : 'Nei'
                ),
                stateApprovedManufacturing: license.licenseType === 'skjenk' && (
                  license.location.stateApprovedManufacturing ? 'Ja' : 'Nei'
                ),
              }}
              />
            </Grid>
          </Grid>
        </InfoCard>
        {license.licenseType === 'skjenk' && (
          <InfoCard elevation={2} className={classes.card}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" color="primary">Åpningstid</Typography>
                <ListValues values={{
                  alcoholServingHoursIndoor: license.location.alcoholServingHoursUntil
                    && license.location.alcoholServingHoursUntil.indoors,
                  openingHoursIndoor: (license.location.openingHoursUntil
                    && license.location.openingHoursUntil.indoors)
                    || (license.location.alwaysOpen && 'Døgnåpent'),
                  alcoholServingHoursOutdoor: license.location.alcoholServingHoursUntil
                    && license.location.alcoholServingHoursUntil.outdoor,
                  openingHoursOutdoor: license.location.openingHoursUntil
                    && license.location.openingHoursUntil.outdoor,
                }}
                />
              </Grid>
            </Grid>
          </InfoCard>
        )}
        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">Bevilling</Typography>
              <ListValues values={{
                licensePeriod: !license.isAmbulatory && formatLicenseDatePeriod(license),
                ceo: license.people && license.people.licenseDL
                  && license.people.licenseDL.firstName
                  && `${license.people.licenseDL.firstName} ${license.people.licenseDL.lastName}`,
                manager: license.people && license.people.licenseManager
                  && license.people.licenseManager.firstName
                  && `${license.people.licenseManager.firstName} ${license.people.licenseManager.lastName}`,
                deputy: license.people && license.people.licenseDeputy
                  && license.people.licenseDeputy.firstName
                  && `${license.people.licenseDeputy.firstName} ${license.people.licenseDeputy.lastName}`,
                outdoorEvent: license.isAmbulatory && license.event.outdoor ? 'Ja' : null,
                tent: license.isAmbulatory && license.event.tent ? 'Ja' : null,
                festivalOrLargeEvent: license.licenseType === 'ea-skjenk' && license.event.festivalOrLargeEvent ? 'Ja' : null,
                wholesale: license.licenseType === 'ea-skjenk' && license.event.wholesale ? 'Ja' : null,
                group3: license.licenseType === 'ea-skjenk' && license.event.group3 ? 'Ja' : null,
                expectedVisitorCount: license.licenseType === 'ea-skjenk' ? license.event.expectedVisitorCount : null,
                description: license.isAmbulatory && license.event.description,
              }}
              />
            </Grid>
          </Grid>
        </InfoCard>
        {license.isAmbulatory && (
          <InfoCard elevation={2} className={classes.card}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" color="primary">Enkeltanledning-perioder</Typography>
                {license.dates.sort(sortByNewestFromStr).reverse().map((datePeriod, index) => (
                  <Typography
                    key={JSON.stringify(datePeriod)}
                    variant="body1"
                  >
                    <br />
                    <strong>{`Periode ${index + 1}: `}</strong>
                    <br />
                    {`- Fra/til dato: ${formatDatePeriod(datePeriod.from, datePeriod.to)}`}
                    <br />
                    {`- Lokasjon: ${datePeriod.location}`}
                    {datePeriod.responsible.name !== '' ? (
                      <>
                        <br />
                        {`- Ansvarlig person: ${datePeriod.responsible.name}`}
                      </>
                    ) : ''}
                    {license.licenseType === 'ea-skjenk' && datePeriod.openToIndoors ? (
                      <>
                        <br />
                        {`- Åpningstid inne: ${dateTimeStrToHourAndMin(datePeriod.openToIndoors, true, true)}`}
                      </>
                    ) : ''}
                    {license.licenseType === 'ea-skjenk' && license.event.outdoor && datePeriod.openToOutdoors ? (
                      <>
                        <br />
                        {`- Åpningstid ute: ${dateTimeStrToHourAndMin(datePeriod.openToOutdoors, true, true)}`}
                      </>
                    ) : ''}
                    {license.licenseType === 'ea-skjenk' && datePeriod.alcoholServingToIndoors ? (
                      <>
                        <br />
                        {`- Skjenketid inne: ${dateTimeStrToHourAndMin(datePeriod.alcoholServingToIndoors, true, true)}`}
                      </>
                    ) : ''}
                    {license.licenseType === 'ea-skjenk' && license.event.outdoor && datePeriod.alcoholServingToOutdoors ? (
                      <>
                        <br />
                        {`- Skjenketid ute: ${dateTimeStrToHourAndMin(datePeriod.alcoholServingToOutdoors, true, true)}`}
                      </>
                    ) : ''}
                    <br />
                  </Typography>
                ))}

              </Grid>
            </Grid>
          </InfoCard>
        )}
        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">Tidligere kontroller</Typography>
              {(!oldControls || oldControls.length === 0) && (
                <Typography variant="subtitle1">Ingen</Typography>
              )}
              {oldControls && oldControls.length > 0 && (
                <StyledTable
                  header={[
                    'Dato',
                    'Brudd',
                    '',
                  ]}
                  rowsPerPage={10}
                >
                  {oldControls.sort(sortByNewestStartTime).map((oldControl, index) => (
                    <CustomTableRow
                      key={oldControl.sysId}
                      onClick={() => history.push(`${license.sysId}/kontroll--${oldControl.sysId}`)}
                      odd={!(index % 2)}
                    >
                      <CustomTableCell>{formatDate(oldControl.startTime)}</CustomTableCell>
                      <CustomTableCell>
                        <span className={
                          clsx(oldControl.violationsSeverity !== 0 ? classes.red : null)
                        }
                        >
                          {getViolationSeverityStr(oldControl.violationsSeverity)}
                        </span>
                      </CustomTableCell>
                      <CustomTableCell shrink>
                        <ArrowForwardIcon color="primary" />
                      </CustomTableCell>
                    </CustomTableRow>
                  ))}
                </StyledTable>
              )}
            </Grid>
          </Grid>
        </InfoCard>
        {(license.licenseType === 'tobakk' || license.licenseType === 'tobakk-midlertidig') && (
          <InfoCard elevation={2} className={classes.card}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" color="primary">Reaksjoner</Typography>
                {(!reactionsPayload || reactionsPayload.length === 0) && (
                  <Typography variant="subtitle1">Ingen</Typography>
                )}
                {reactionsPayload && reactionsPayload.length > 0 && (
                  <StyledTable
                    header={[
                      'Nummer',
                      'Type reaksjon',
                      'Status',
                      'Kommentar til retting',
                      'Frist for uttalelse',
                      'Uttalelse fra bev.haver',
                    ]}
                    rowsPerPage={10}
                  >
                    {reactionsPayload.sort(sortByNumberAlphabetically).map((reaction, index) => (
                      <CustomTableRow
                        key={reaction.sys_id}
                        odd={!(index % 2)}
                      >
                        <CustomTableCell>{reaction.number.value}</CustomTableCell>
                        <CustomTableCell>{reaction.reaksjon.display_value}</CustomTableCell>
                        <CustomTableCell>{reaction.status.display_value}</CustomTableCell>
                        <CustomTableCell>
                          <div className={classes.largeReactionCell}>
                            {reaction.kommentar_til_retting.display_value}
                          </div>
                        </CustomTableCell>
                        <CustomTableCell>
                          {reaction.frist_for_uttalelse.display_value}
                        </CustomTableCell>
                        <CustomTableCell>
                          {reaction.uttalelse_fra_bevillingshaver.display_value}
                        </CustomTableCell>
                      </CustomTableRow>
                    ))}
                  </StyledTable>
                )}
              </Grid>
            </Grid>
          </InfoCard>
        )}
      </div>
    );
  }
}

const styles = theme => ({
  loading: {
    margin: theme.spacing(15),
    textAlign: 'center',
  },
  red: {
    color: 'red',
  },
  card: {
    marginBottom: '1rem',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  largeReactionCell: {
    width: '20rem',
  },
});

License.propTypes = {
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  assignments: PropTypes.object.isRequired,
  licenses: PropTypes.object.isRequired,
  activeWorkPlan: PropTypes.object,
  licenseControls: PropTypes.object.isRequired,
  licenseReactions: PropTypes.object.isRequired,
};

License.defaultProps = {
  activeWorkPlan: null,
};

const mapStateToProps = ({
  assignments,
  licenses,
  licenseControls,
  licenseReactions,
  form: {
    activeWorkPlan,
  },
}) => ({
  assignments, licenses, licenseControls, licenseReactions, activeWorkPlan,
});

export default connect(mapStateToProps)(withRouter(withStyles(styles)(License)));
